import { createFileRoute } from "@tanstack/react-router"
import DesignSystemCommandBar from "~/pages/design-system/components/CommandBar"

export const Route = createFileRoute("/_auth/internal/design-system/components/command-bar")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemCommandBar />
}
